export const FLICKING_BULLET_ANIMATION_NAME = 'flicking-autoplay-bullet'
export const EASE_SWING = 'cubic-bezier(0.56, 0.04, 0.25, 1)'
